import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";

import useFetch from "./hooks/useFetch";
import CreateRoutes from "./routes";
import { getSiteSettingList } from "./services/siteSettingService";
import { getSettings } from "./redux/slice/settingsSlice";
import { verifyAuth } from "./redux/slice/authSlice";

import { HelmetProvider } from "react-helmet-async";
import { BannerProvider } from "./providers/BannerProviders";
import { ToastContainer } from "react-toastify";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { getCartList } from "./services/cartService";
import { setCartDetails } from "./redux/slice/cartSlice";
import { stepsList } from "./services/stepService";
import { restoreStepFromStorage, setSteps } from "./redux/slice/stepSlice";
import { pushMetaUserData } from "./util/metaUserData";

// import { SocketProvider } from "./providers/SocketContext";

function App() {
  const dispatch = useDispatch();
  const location = useLocation();

  const { session } = useSelector((state) => state?.authProvider);
  const profile = useSelector((state) => state?.profile?.data);
  const userId = session?.user?._id;
  const role = session?.user?.role;

  // Meta advanced matching: identify the signed-in customer to the pixel (via
  // GTM) before any AddToCart or funnel event fires. See util/metaUserData.js.
  useEffect(() => {
    if (profile?._id) pushMetaUserData(profile);
  }, [profile]);
  // Fetch site settings
  useFetch({
    dependencies: ["siteSetting"],
    fetchFunction: async () => {
      const res = await getSiteSettingList();
      dispatch(getSettings(res?.data));
      return res?.data;
    },
  });

  useEffect(() => {
    dispatch(verifyAuth());
  }, []);

  useEffect(() => {
    const loadSteps = async () => {
      try {
        const res = await stepsList();
        if (res?.docs?.status === 200 && res?.docs?.data?.[0]?.steps) {
          dispatch(setSteps(res.docs.data[0].steps));
        }
      } catch (err) {
        console.error("Failed to fetch steps", err);
      }
    };

    if (!!userId) loadSteps();
  }, [userId]);

  useEffect(() => {
    const pathsToBlock = ["/cover-image", "/create"];

    if (!pathsToBlock.includes(location.pathname)) return;
    const handleBeforeUnload = (e) => {
      const message =
        "Are you sure you want to leave? Your progress may be lost.";
      e.preventDefault();
      e.returnValue = message; // Some browsers require this
      return message;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [location.pathname]);

  return (
    <HelmetProvider>
      <BannerProvider>
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        {/* <SocketProvider> */}
        <CreateRoutes />
        {/* </SocketProvider> */}
      </BannerProvider>
    </HelmetProvider>
  );
}

export default App;
